module.exports = __webpack_public_path__ + "img/main.2ef0ba3c.jpg";